import { render, staticRenderFns } from "./AddOrderItem.vue?vue&type=template&id=163bc2c0&scoped=true"
import script from "./AddOrderItem.vue?vue&type=script&lang=js"
export * from "./AddOrderItem.vue?vue&type=script&lang=js"
import style0 from "./AddOrderItem.vue?vue&type=style&index=0&id=163bc2c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163bc2c0",
  null
  
)

export default component.exports